__turbopack_context__.v({
  "arrowBadge": "WhitePaperCard-module__Q-rwDa__arrowBadge",
  "card": "WhitePaperCard-module__Q-rwDa__card",
  "dateText": "WhitePaperCard-module__Q-rwDa__dateText",
  "foot": "WhitePaperCard-module__Q-rwDa__foot",
  "pill": "WhitePaperCard-module__Q-rwDa__pill",
  "pillLabel": "WhitePaperCard-module__Q-rwDa__pillLabel",
  "readLabel": "WhitePaperCard-module__Q-rwDa__readLabel",
  "swatch": "WhitePaperCard-module__Q-rwDa__swatch",
  "title": "WhitePaperCard-module__Q-rwDa__title",
  "top": "WhitePaperCard-module__Q-rwDa__top",
});
